<template>
    <div v-if="checkCorrect === 'correct' ">
        <Correct :resetGame="resetGame" :star="star" :nextCheckPoint="nextCheckPoint"/>
    </div>
    <div v-else-if="checkCorrect === 'incorrect' ">        
        <InCorrect :resetGame="resetGame" :nextCheckPoint="nextCheckPoint"/>
    </div>
    <h1 v-else></h1> 
</template>

<script>

import Correct from "./Correct.vue";
import InCorrect from "./InCorrect.vue";

export default {
    name: "Answer",
    components: {
        Correct,
        InCorrect
    },
    props: {
        checkCorrect: String,
        resetGame: Function,
        nextCheckPoint: Function,
        star: Number      
    }    
};
</script>